module.exports = __webpack_public_path__ + "static/media/StarWars-TTT.c5937d20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/StarWars-TTT.png
// module id = 401
// module chunks = 0